const { doAction } = require('./index');

const FAILED_CREATE_MESSAGE = 'Failed to create a new school';
const SUCCEEDED_CREATE_MESSAGE = 'School created';
const CREATED_SCHOOL = 'CREATED_SCHOOL';
const CREATING_SCHOOL = 'CREATING_SCHOOL';

const FAILED_DELETE_MESSAGE = 'Deletion failed';
const SUCCEEDED_DELETE_MESSAGE = 'School deleted';
const DELETED_SCHOOL = 'DELETED_SCHOOL';
const DELETING_SCHOOL = 'DELETING_SCHOOL';

const FAILED_FETCH_MESSAGE =
	'Failed to retrieve the list of schools from the server';
const FETCHED_SCHOOLS = 'FETCHED_SCHOOLS';
const FETCHING_SCHOOLS = 'FETCHING_SCHOOLS';

const SELECT_SCHOOL = 'SELECT_SCHOOL';

const FAILED_UPDATE_MESSAGE = 'Update failed';
const SUCCEEDED_UPDATE_MESSAGE = 'School updated';
const UPDATED_SCHOOL = 'UPDATED_SCHOOL';
const UPDATING_SCHOOL = 'UPDATING_SCHOOL';

const url = '/api/schools';

module.exports = {
	FAILED_CREATE_MESSAGE,
	CREATED_SCHOOL,
	CREATING_SCHOOL,

	FAILED_DELETE_MESSAGE,
	DELETED_SCHOOL,
	DELETING_SCHOOL,

	FAILED_FETCH_MESSAGE,
	FETCHED_SCHOOLS,
	FETCHING_SCHOOLS,

	SELECT_SCHOOL,

	FAILED_UPDATE_MESSAGE,
	UPDATED_SCHOOL,
	UPDATING_SCHOOL,

	createSchool(school) {
		const method = 'post';
		const payload = school;
		const doingActionType = CREATING_SCHOOL;
		const didActionType = CREATED_SCHOOL;
		const failureMessage = FAILED_CREATE_MESSAGE;
		const successMessage = SUCCEEDED_CREATE_MESSAGE;

		return doAction(
			url,
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			successMessage
		);
	},

	deleteSchool(schoolId) {
		const endpoint = `${ url }/${ schoolId }`;
		const method = 'delete';
		const payload = { id: schoolId };
		const doingActionType = DELETING_SCHOOL;
		const didActionType = DELETED_SCHOOL;
		const failureMessage = FAILED_DELETE_MESSAGE;
		const successMessage = SUCCEEDED_DELETE_MESSAGE;

		return doAction(
			endpoint,
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			successMessage
		);
	},

	fetchSchools() {
		const method = 'get';
		const payload = null;
		const doingActionType = FETCHING_SCHOOLS;
		const didActionType = FETCHED_SCHOOLS;
		const failureMessage = FAILED_FETCH_MESSAGE;

		return doAction(
			url,
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage
		);
	},

	selectSchool(school) {
		return {
			type: SELECT_SCHOOL,
			payload: {
				school
			}
		};
	},

	updateSchool(school) {
		const endpoint = `${ url }/${ school.id }`;
		const method = 'PATCH';
		const payload = school;
		const doingActionType = UPDATING_SCHOOL;
		const didActionType = UPDATED_SCHOOL;
		const failureMessage = FAILED_UPDATE_MESSAGE;
		const successMessage = SUCCEEDED_UPDATE_MESSAGE;

		return doAction(
			endpoint,
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			successMessage
		);
	}
};



// WEBPACK FOOTER //
// ./frontend/a2i/js/actions/schools.js